module.exports = __webpack_public_path__ + "static/media/red_trailer.436f12d5.svg";